import React from "react";

import {
    Card,
    Empty,
    List,
    Tag,
    Typography
} from "antd";

import {
    CarOutlined
} from "@ant-design/icons";

const {
    Text,
    Title
} = Typography;


const DELIVERY_STATUS = {

    PENDING: {
        label: "Livraison en attente",
        color: "gold"
    },

    IN_PROGRESS: {
        label: "Livraison en cours",
        color: "processing"
    },

    DELIVERED: {
        label: "Livrée",
        color: "success"
    },

    COMPLETED: {
        label: "Terminée",
        color: "success"
    }

};


const DeliveryList = ({
                          orders = []
                      }) => {

    if (!orders.length) {
        return (
            <Empty
                description="Aucune livraison"
            />
        );
    }

    return (
        <List
            dataSource={orders}
            rowKey={order => order.id}
            renderItem={order => {

                const status =
                    DELIVERY_STATUS[
                        order.deliveryStatus
                        ] || {
                        label:
                            order.deliveryStatus ||
                            "Inconnu",
                        color: "default"
                    };

                return (

                    <List.Item>

                        <Card
                            style={{
                                width: "100%",
                                borderRadius: 12
                            }}
                        >

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent:
                                        "space-between",
                                    alignItems:
                                        "flex-start"
                                }}
                            >

                                <div>

                                    <Title
                                        level={5}
                                    >
                                        <CarOutlined />
                                        {" "}
                                        Livraison
                                    </Title>

                                    <Text
                                        type="secondary"
                                    >
                                        Commande :{" "}
                                        {order.id}
                                    </Text>

                                </div>

                                <Tag
                                    color={status.color}
                                >
                                    {status.label}
                                </Tag>

                            </div>

                            {order.deliveryAddress && (

                                <div
                                    style={{
                                        marginTop: 12
                                    }}
                                >

                                    <Text strong>
                                        Adresse
                                    </Text>

                                    <div>
                                        {order.deliveryAddress}
                                    </div>

                                </div>

                            )}

                        </Card>

                    </List.Item>

                );
            }}
        />
    );
};

export default DeliveryList;